import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AnyAction } from 'redux'
import { Form, InputNumber, Row, Col, Switch, Radio, Select, Checkbox, Divider, Space, Button, Alert } from 'antd';
import { toast } from 'react-toastify'
import { ApplicationState } from '../../../store'
import { requestAuthInit } from '../../../store/auth/auth.actions'
import TitleBar from '../../../components/Elements/TitleBar'
import PatternNumber from '../../../utils/PatternNumber'
import { getRewardItems } from '../../../utils/Wheel'
import { WheelConfig } from '../../../@types/prefix'
import { ThunkDispatch } from '../../../@types/store'
import PrefixService from "../../../services/prefix"

const PromotionWheelLuck = () => {
    const { prefix } = useSelector((state: ApplicationState) => state.prefix)

    const dispatch: ThunkDispatch<AnyAction> = useDispatch()
    const [btnLoading, setBtnLoading] = useState<boolean>(false)
    const [rewardItemInput, setRewardItemInput] = useState<any>()
    const [rewardPrecent, setRewardPrecent] = useState<number>(0)
    const [form] = Form.useForm();
    const { Option } = Select;

    const updateData = async (values: WheelConfig) => {
        try {
            const res = await PrefixService.saveWheelConfig(values)
            dispatch(requestAuthInit(false))
            toast.success(res.message)
            setBtnLoading(false)
        } catch ({ message }) {
            toast.error(message as string)
            setBtnLoading(false)
        }
    }

    const handleFormSubmit = () => {
        form.validateFields()
            .then(async (values: WheelConfig) => {
                const rewards = await getRewardItems(values.rewardType);
                await Object.values(values.rewards || []).forEach((val: any, x: number) => {
                    const keyRewards = Object.keys(rewards)[x]
                    Object(rewards)[keyRewards].chance = Object(values.rewards)[keyRewards].chance
                }
                )
                values.rewards = await rewards
                setBtnLoading(true)
                updateData(values)
            })
            .catch((errorInfo) => {

            });
    };

    const setRewardType = (t: string) => {
        form.setFieldsValue({ 'rewardType': t, 'rewards': getRewardItems(t) })
        rewardItems(getRewardItems(t), t)
    }

    const rewardItems = (rewardItemsWheel: any, type: string) => {
        const rewardItemKeys = Object.keys(rewardItemsWheel).sort((a, b) => {
            if (rewardItemsWheel[a].index > rewardItemsWheel[b].index) {
                return 1
            }
            return -1
        })
        const rewardItemInputs = []
        for (let i = 0; i < rewardItemKeys.length / 2; i++) {
            const reward1Key = rewardItemKeys[i * 2],
                reward2Key = rewardItemKeys[i * 2 + 1]
            const reward1 = rewardItemsWheel[reward1Key]
            const reward2 = rewardItemsWheel[reward2Key]

            rewardItemInputs.push(
                <Row gutter={16} key={i}>
                    <Col span={12}>
                        {reward1 && (
                            <Form.Item
                                name={["rewards", `${reward1Key}`, "chance"]}
                                key={`rewards-${reward1Key}`}
                                label={reward1.name}
                                rules={[{ required: true, message: 'กรุณากรอกข้อมูล' + reward1.name }]}
                                hasFeedback>
                                <InputNumber placeholder={reward1.name} inputMode="numeric" addonAfter="%" controls={false} />
                            </Form.Item>
                        )}
                    </Col>
                    <Col span={12}>
                        {reward2 && (
                            <Form.Item
                                name={["rewards", `${reward2Key}`, "chance"]}
                                key={`rewards-${reward2Key}`}
                                label={reward2.name}
                                rules={[{ required: true, message: 'กรุณากรอกข้อมูล' + reward2.name }]}
                                hasFeedback>
                                <InputNumber placeholder={reward2.name} inputMode="numeric" addonAfter="%" controls={false} />
                            </Form.Item>
                        )}
                    </Col>
                </Row>
            )
            if (type === prefix?.setting?.wheel?.rewardType) {
                form.setFieldsValue({ "rewards": prefix?.setting?.wheel?.rewards })
            }
            setRewardItemInput(rewardItemInputs)
        }
    }

    useEffect(() => {
        if (form) {
            form.resetFields();
            form.setFieldsValue(prefix?.setting?.wheel)
            rewardItems(getRewardItems(prefix?.setting?.wheel?.rewardType), prefix?.setting?.wheel?.rewardType)
            sumRewardPrecent()
        }
    }, [form])// eslint-disable-line


    useEffect(() => {
        if (form) {
            sumRewardPrecent()
        }
    }, [form, setRewardType])// eslint-disable-line

    const sumRewardPrecent = () => {
        const sumReward = form.getFieldsValue().rewards ? Object.values(form.getFieldsValue().rewards).reduce(
            (val: number, { chance }: any) => val + parseFloat(chance > 0 ? chance : 0),
            0
        ) : 0

        setRewardPrecent(sumReward)

        // return Object.values(form.getFieldsValue().rewards || []).reduce(
        //     (val, x: any) => val + x.chance,
        //     0
        // )
    }

    return (
        <Fragment>
            <TitleBar title="จัดการกงล้อเสี่ยงโชค" />
            <div className="box-white ant-box-card">
                <Form
                    form={form}
                    name="wheelLuckForm"
                    layout="vertical"
                    onValuesChange={sumRewardPrecent}
                    hideRequiredMark
                >

                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="สถานะ"
                                name="enable"
                                valuePropName="checked">
                                <Switch
                                    checkedChildren="เปิด"
                                    unCheckedChildren="ปิด"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                label="ประเภทรางวัล"
                                name="rewardType"
                                rules={[{ required: true, message: 'กรุณาเลือกประเภทรางวัล' }]}>
                                <Radio.Group buttonStyle="solid">
                                    <Radio.Button value="type1" onClick={() => setRewardType('type1')}>ประเภทที่ 1</Radio.Button>
                                    <Radio.Button value="type2" onClick={() => setRewardType('type2')}>ประเภทที่ 2</Radio.Button>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="rewardLimit"
                                label="จำกัดการเล่น"
                                rules={[{ required: true, message: 'กรุณาเลือกการจำกัดการเล่น' }]}
                                hasFeedback>
                                <Select
                                    placeholder="เลือกการจำกัดการเล่น"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    <Option key={'every_hour'} value={'every_hour'}>เล่นได้ทุก 1 ชั่วโมง</Option>
                                    <Option key={'every_day'} value={'every_day'}>เล่นได้ทุกวัน</Option>
                                    <Option key={'every_week'} value={'every_week'}>เล่นได้ทุกสัปดาห์</Option>
                                    <Option key={'every_month'} value={'every_month'}>เล่นได้ทุกเดือน</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="minDeposit"
                                label="ยอดฝากขั้นต่ำ"
                                rules={[
                                    { required: true, message: 'กรุณากรอกยอดฝากขั้นต่ำ' },
                                    { pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }
                                ]}
                                hasFeedback>
                                <InputNumber placeholder="ยอดฝากขั้นต่ำ" inputMode="numeric" controls={false} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="depositType"
                                label="ประเภทยอดฝาก"
                                rules={[{ required: true, message: 'กรุณาเลือกการประเภทยอดฝาก' }]}
                                hasFeedback>
                                <Select
                                    placeholder="เลือกการประเภทยอดฝาก"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    <Option key={'sum'} value={'sum'}>ยอดฝากรวม</Option>
                                    <Option key={'tx'} value={'tx'}>ยอดฝากรายครั้ง</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="rewardTurn"
                                label="เทิร์น (เท่า)"
                                rules={[
                                    { required: true, message: 'กรุณากรอกเทิร์น (เท่า)' },
                                    { pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }
                                ]}
                                hasFeedback>
                                <InputNumber placeholder="เทิร์น (เท่า)" inputMode="numeric" controls={false} />
                            </Form.Item>
                        </Col>
                    </Row>
                    {rewardItemInput}
                    <Alert message={`ยอดรวม : ${rewardPrecent}%`} type="warning" />
                    <Row gutter={16}>
                        <Col span={24}>
                            <h6 className="my-3">เงื่อนไขกงล้อเสี่ยงโชค</h6>
                            <Form.Item
                                name={['rules', 'minCredit']}
                                key="minCredit"
                                valuePropName="checked"
                                className="mb-0">
                                <Checkbox>
                                    ต้องมีเครดิตคงเหลือน้อยกว่า {prefix?.setting?.minCredit}
                                </Checkbox>
                            </Form.Item>
                            <Form.Item
                                name={['rules', 'noWithdraw']}
                                key="noWithdraw"
                                valuePropName="checked"
                                className="mb-0">
                                <Checkbox>
                                    ต้องไม่มีรายการถอน (ของรายการฝาก)
                                </Checkbox>
                            </Form.Item>
                            <Form.Item
                                name={['rules', 'noBonus']}
                                key="noBonus"
                                valuePropName="checked"
                                className="mb-0">
                                <Checkbox>
                                    ต้องไม่มีรายการรับโบนัส (ของรายการฝาก)
                                </Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <div className="drawer-actions">
                        <Space>
                            <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large"><i className="fa-solid fa-save me-2"></i> บันทึก</Button>
                        </Space>
                    </div>
                </Form>
            </div>
        </Fragment>
    )
}

export default PromotionWheelLuck